// Source: https://codepen.io/jkantner/pen/ExJmxZy
document.addEventListener('DOMContentLoaded', function() {
  class MyForm {
    constructor(el) {
      this.el = $(el);
      this.form = this.el.parents('form');
      this.identifierFormElement = '#' + this.form.attr('id') + '-form-chose-any-id';

      this._accessMode = $(this.identifierFormElement).val() === 'private' ? 0 : 1; // Default option set by hidden form field

      const switch0 = this.el.find('[data-switch-value-0]');
      const switch1 = this.el.find('[data-switch-value-1]');
      this.switchValues = [
        switch0.length > 0 ? switch0.val() : null,
        switch1.length > 0 ? switch1.val() : null,
      ];

      this.setAccessMode(this._accessMode);
      this.initEventListeners();
      this.updateSwitchValue();
    }

    initEventListeners() {
      this.el.find('[data-action="access"]').on('click', (e) => this.handleButtonClick(e));
    }

    handleButtonClick(e) {
      const accessMode = parseInt($(e.target).attr('data-access'));
      this.setAccessMode(accessMode);
    }

    setAccessMode(value) {
      const currentSelected = this.el.find('[aria-selected="true"]');
      const newSelected = this.el.find(`[data-access="${value}"]`);

      currentSelected.attr('aria-selected', 'false');
      newSelected.attr('aria-selected', 'true');

      this._accessMode = value;
      this.updateSwitchValue();
    }

    toggleDisplayClass(element, isActive) {
      const displayClass = element.is('span')
        ? 'd-inline'
        : element.hasClass('row')
        ? 'd-flex'
        : 'd-block';
      element.toggleClass(displayClass, isActive).toggleClass('d-none', !isActive);
    }

    handleSwitchElements(dataAttribute, isActive) {
      this.el
        .closest('form')
        .find(`[${dataAttribute}]`)
        .each((index, elem) => {
          const element = $(elem);
          this.toggleDisplayClass(element, isActive);
        });
    }

    updateSwitchValue() {
      const switchValueElement = this.el.find('[data-switch-value]');
      if (switchValueElement.length > 0) {
        switchValueElement.val(this.switchValues[this._accessMode]);
      }

      this.handleSwitchElements('data-switch-value-0', this._accessMode === 0);
      this.handleSwitchElements('data-switch-value-1', this._accessMode === 1);
      this.handleSwitchElements('data-switch-value="0"', this._accessMode === 0);
      this.handleSwitchElements('data-switch-value="1"', this._accessMode === 1);

      $(this.identifierFormElement).attr(
        'value',
        this.form
          .find('button.kid-form__switch-segmented-btn[data-access="' + this._accessMode + '"]')
          .attr('data-type')
      );
    }
  }

  $('.kid-form__switch').each(function() {
    new MyForm(this);
  });
});
